import { Flex, Heading, useDisclosure, Text, Link, Button, Box } from '@chakra-ui/core'
import React from 'react'
import { BsFolderPlus } from 'react-icons/bs'
import { useAppContext } from '../../../context/AppProvider'
import { usePreviewerContext } from '../../../context/PreviewerProvider'
import {
  Maybe,
  PopularTaskDefinitionEntityWithCount,
  TaskDefinitionEntity
} from '../../../generated/graphql'
import ListItem from './Tasks/ListItem'
import PopularListItem from './PopularTasks/ListItem'
import DataFields from './DataFields'
import { AlertModal } from '../../../components'
import { VscScreenFull } from 'react-icons/vsc'

type ListProps = {
  tasks: Maybe<TaskDefinitionEntity>[] | Maybe<PopularTaskDefinitionEntityWithCount>[]
  setSelectedTask?: React.Dispatch<React.SetStateAction<string | null>>
  selectedTask?: string | null
}
const List: React.FC<ListProps> = ({ tasks, setSelectedTask, selectedTask }) => {
  const { setPreviewComponent, formIsDirty, setFormIsDirty } = usePreviewerContext()
  const { toggleDrawer2 } = useAppContext()

  const arePopularTask = tasks?.[0]?.__typename === 'PopularTaskDefinitionEntityWithCount'

  const { isOpen, onOpen, onClose } = useDisclosure()
  const onConfirm = React.useRef(() => {
    toggleDrawer2(true)
    setPreviewComponent?.({
      title: '',
      icon: BsFolderPlus,
      content: <DataFields task={null} key={Date.now()} />
    })
  })
  return (
    <Box key={Date.now()}>
      <AlertModal
        activatorStatus="warning"
        onConfirm={() => {
          onConfirm.current()
          setFormIsDirty?.(false)
          onClose()
        }}
        isOpen={isOpen}
        onClose={onClose}
        confirmButtonText="Confirm"
        title="Unsaved Changes"
      >
        <Heading fontSize="xs">
          You have unsaved changes. Are you sure you want to continue?
        </Heading>
        <Text fontSize="xs" mt={5}>
          Any unsaved changes will be lost if you proceed.
        </Text>
      </AlertModal>

      <Flex
        wrap="wrap"
        w="100%"
        direction={arePopularTask ? 'row' : 'column'}
        justifyContent="flex-start"
      >
        {tasks?.map((task) =>
          task?.__typename === 'TaskDefinitionEntity' ? (
            <ListItem
              key={task?.id}
              bg={selectedTask === task?.id ? 'green.50' : 'white'}
              border="1px solid"
              borderColor={selectedTask === task?.id ? 'green.100' : 'transparent'}
              task={task}
              onClick={() => {
                if (selectedTask === task?.id) {
                  toggleDrawer2(true)
                  return
                }
                const select = () => {
                  setSelectedTask?.(task?.id || null)

                  setPreviewComponent?.({
                    title: task?.attributes?.task_type?.data?.attributes?.title || '',
                    icon: BsFolderPlus,
                    content: <DataFields task={task} key={`${task?.id}-${Date.now()}`} />
                  })

                  toggleDrawer2(true)
                }
                if (formIsDirty) {
                  onOpen()
                  onConfirm.current = select

                  toggleDrawer2(true)
                  return
                }
                select()
              }}
            />
          ) : task?.__typename === 'PopularTaskDefinitionEntityWithCount' ? (
            <PopularListItem
              key={task?.taskDefinition.id}
              task={task}
              bg={selectedTask === task?.taskDefinition.id ? 'green.50' : 'white'}
              border="1px solid"
              borderColor={selectedTask === task?.taskDefinition.id ? 'green.100' : 'transparent'}
              onClick={() => {
                if (selectedTask === task?.taskDefinition.id) {
                  toggleDrawer2(true)
                  return
                }
                const select = () => {
                  setSelectedTask?.(task?.taskDefinition.id || null)

                  setPreviewComponent?.({
                    title:
                      task?.taskDefinition?.attributes?.task_type?.data?.attributes?.title || '',
                    icon: BsFolderPlus,
                    action: (
                      <Link href={`/auth/report-tasks/${task?.taskDefinition.id}`}>
                        <Button
                          as="a"
                          variantColor="green"
                          variant="ghost"
                          leftIcon={VscScreenFull}
                          size="xs"
                          mt={2}
                        >
                          Open In Full Screen
                        </Button>
                      </Link>
                    ),
                    content: (
                      <DataFields
                        task={task.taskDefinition}
                        key={`${task?.taskDefinition.id}-${Date.now()}`}
                      />
                    )
                  })

                  toggleDrawer2(true)
                }
                if (formIsDirty) {
                  onOpen()
                  onConfirm.current = select

                  toggleDrawer2(true)
                  return
                }
                select()
              }}
            />
          ) : (
            <></>
          )
        )}
      </Flex>
    </Box>
  )
}

export default List
